export default "__VITE_ASSET__Dm4P3wEj__"